export type RangeValue = {
  min?: string;
  max?: string;
};

export type RangeFilter = {
  min?: string;
  max?: string;
};

export type ColumnFilterValue = string | string[] | RangeFilter | RangeFilter[] | undefined;

const toFilterInput = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return undefined;
};

export const isDateValue = (value: unknown) => {
  if (typeof value !== 'string') return false;
  return /^\d{4}-\d{2}-\d{2}/.test(value);
};

export const toNumber = (value?: string) => {
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const toDateMs = (value?: string) => {
  if (!value) return undefined;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const rangeFilter = (
  row: { getValue: (columnId: string) => unknown },
  columnId: string,
  value: RangeValue,
  parser: (input?: string) => number | undefined
) => {
  const raw = row.getValue(columnId);
  const current = parser(toFilterInput(raw));
  const min = parser(value.min);
  const max = parser(value.max);

  if (current === undefined) return false;
  if (min !== undefined && current < min) return false;
  if (max !== undefined && current > max) return false;
  return true;
};

export const matchesTextFilters = (cellValue: unknown, filters: string[]) => {
  if (!filters.length) return true;
  const raw = (toFilterInput(cellValue) ?? '').toLowerCase();
  return filters.every(filter => raw.includes(filter.toLowerCase()));
};

export const matchesRangeFilters = (
  cellValue: unknown,
  filters: RangeFilter[],
  parser: (input?: string) => number | undefined
) => {
  if (!filters.length) return true;
  const current = parser(toFilterInput(cellValue));
  if (current === undefined) return false;
  return filters.every(filter => {
    const min = parser(filter.min);
    const max = parser(filter.max);
    if (min !== undefined && current < min) return false;
    if (max !== undefined && current > max) return false;
    return true;
  });
};
